import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "form-box" }
const _hoisted_4 = { class: "form-content" }
const _hoisted_5 = { class: "inputbox" }
const _hoisted_6 = { class: "button-container" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "table-content" }
const _hoisted_11 = {
  key: 0,
  class: "no-results"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderDots = _resolveComponent("LoaderDots")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "result-title" }, "User Cap Report", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "month",
              id: "reportDate",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMonth) = $event))
            }, null, 512), [
              [_vModelText, _ctx.selectedMonth]
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadReport && _ctx.loadReport(...args))),
              disabled: _ctx.isLoading || !_ctx.selectedMonth
            }, [
              (!_ctx.isLoading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Run Report"))
                : _createCommentVNode("", true),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_LoaderDots, { key: 1 }))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7)
          ])
        ])
      ]),
      (_ctx.hasSearched && !_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_ctx.items.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, " No users exceeded £400 in the selected month. "))
                : (_openBlock(), _createElementBlock("table", _hoisted_12, [
                    _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", { class: "table-header" }, [
                        _createElementVNode("th", null, "User ID"),
                        _createElementVNode("th", null, "Total Amount")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          class: "table-row",
                          key: item.userId
                        }, [
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              href: `/users/${item.userId}`
                            }, _toDisplayString(item.userId), 9, _hoisted_13)
                          ]),
                          _createElementVNode("td", null, "£" + _toDisplayString(item.totalAmount.toFixed(2)), 1)
                        ]))
                      }), 128))
                    ])
                  ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}